import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { User, UserService } from '../../services/user';
import { Role } from '../navigation';

@Component({
  selector: 'to-user-nav',
  templateUrl: './user-nav.component.html',
  styleUrls: ['./user-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserNavComponent implements OnInit {

  @Input() rolesToShow: Role[];

  user: User;

  constructor(
    private userService: UserService,
    private changeRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.userService
      .current()
      .pipe(take(1))
      .subscribe(user => {
        this.user = user;
        this.changeRef.markForCheck();
      });
  }

  signOut() {
    const url = `_layouts/15/SignOut.aspx`;
    window.location.href = url;
  }

  track = (index: number) => index;
}
